<template>
	<div>
		<FunctionTitle :title="title" />
		<CommonFlame :title="pageTitle">
			<GanttChart
				:changeDatetimeFlag="authority == 'editable'"
				:categories="order_individual_infos"
				:tasks="large_processes"
				:categoryNameKey="categoryNameKey"
				:taskNameKey="taskNameKey"
				:startDateKey="startDateKey"
				:endDateKey="endDateKey"
				:startTimeKey="startTimeKey"
				:endTimeKey="endTimeKey"
				:notDistributedTasks="not_distributed_requirements"
				:fontSize="font_size"
				:isWindowSizeCheck="isWindowSizeCheck"
				@change-datetime="changeDatetime($event)"
				@show-task="openShowDialog"
				@add-task="openAddTaskDialog"
			>
				<template v-slot:app-bar-btn>
					<div class="pa-3 d-flex justify-left">
						<v-btn @click="$router.go(-1)" class="mr-2" color="secondary">
							<v-icon>mdi-arrow-u-left-top</v-icon>
							戻る
						</v-btn>
						<ProcessByClassificationGanttChartHelpDialog
							:name="'processByClassificationGanttChart'"
							:openBtnColor="'secondary'"
							:maxWidth="'850px'"
							v-if="authority == 'editable'"
						/>
					</div>
				</template>
				<template v-slot:category="{ task, styleObject, toggleCategory, addTask }">
					<div draggable="false" class="categories">
						<p :style="styleObject" @click="addTask(task.id)" v-text="task[categoryNameKey]" />
						<div class="pr-4" @click="toggleCategory(task.id)">
							<span v-if="!processPresent(task)"> 工程未登録 </span>
							<span v-else-if="task.collapsed && processPresent(task)">
								<v-icon>mdi-chevron-right</v-icon>
							</span>
							<span v-else>
								<v-icon>mdi-chevron-down</v-icon>
							</span>
						</div>
					</div>
				</template>
			</GanttChart>

			<LargeProcessNewDialog
				v-if="authority == 'editable'"
				ref="new_dialog"
				:dialog.sync="addCalendarDialog"
				:order_individual_infos="order_individual_infos"
				:order_individual_info="order_individual_info_id"
				:large_process_types="large_process_types"
				:maxWidth="maxWidth"
				:toolbarTitle="toolbarTitle"
				:plannedStartDate="startDate"
				:plannedEndDate="endDate"
				:disabled="disabled"
				:current_company_name="current_company_name"
				@create-process="createLargeProcess($event)"
				@close="resetDialog"
				@is-window-size-check="isWindowSizeCheck = $event"
			/>
			<LargeProcessShowDialog
				ref="show"
				:order_individual_infos="order_individual_infos"
				:large_process_types="large_process_types"
				:current_company_name="current_company_name"
				@update-process-product="fetchProductAndProcess"
				@update-large-process="updateLargeProcess($event)"
			/>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import GanttChart from "../shared/GanttChart.vue"
import ProcessByClassificationGanttChartHelpDialog from "../shared/HelpDialog.vue"
import LargeProcessNewDialog from "../large_process/components/LargeProcessNewDialog.vue"
import LargeProcessShowDialog from "../large_process/LargeProcessShowDialog.vue"
import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"

export default {
	components: {
		GanttChart,
		ProcessByClassificationGanttChartHelpDialog,
		LargeProcessNewDialog,
		LargeProcessShowDialog,
		CommonFlame,
		FunctionTitle,
	},
	data() {
		return {
			pageTitle: "工程予定表",
			title: "",
			changeDatetimeFlag: false,
			order_individual_infos: [],
			large_processes: [],
			addCalendarDialog: false,
			large_process_types: [],
			authority: null,
			toolbarTitle: "工程追加",
			startDate: null,
			endDate: null,
			maxWidth: "900px",
			errors: [],
			largeProcessType: null,
			largeProcessTypeValue: null,
			startDate: null,
			endDate: null,
			order_individual_info: null,
			not_distributed_requirements: [],
			font_size: "14px",
			categoryNameKey: "name",
			taskNameKey: "name",
			startDateKey: "planned_start_date",
			endDateKey: "planned_end_date",
			startTimeKey: "planned_start_time",
			endTimeKey: "planned_end_time",
			addLargeProcessDialog: false,
			id: this.$route.params["id"],
			order_individual_info_id: null,
			disabled: true,
			current_company_name: null,
			common,
			isWindowSizeCheck: false,
		}
	},
	mounted() {
		authenticate.authenticateUser()
		this.fetchProductAndProcess()
	},
	methods: {
		fetchProductAndProcess() {
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/process_by_classification_ganttchart", {
					params: { id: this.id },
					headers,
				})
				.then((res) => {
					this.order_individual_infos = res.data.order_individual_infos.map(function (value) {
						value.collapsed = false
						value.name = common.productNameWithProductNumber(value, true)
						return value
					})
					this.large_processes = res.data.large_processes.map(function (value) {
						value.name = value.large_process_type.name
						value.category_id = value.order_individual_info_id
						return value
					})
					this.large_process_types = res.data.large_process_types
					this.authority = res.data.authority
					this.current_company_name = res.data.current_company_name
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		resetDialog() {
			this.addCalendarDialog = false
			this.isWindowSizeCheck = false
			this.startDate = null
			this.endDate = null
			this.order_individual_info = null
		},
		createLargeProcess(process) {
			this.large_processes.push({
				...process,
				name: process.large_process_type.name,
				category_id: process.order_individual_info_id,
			})
		},
		updateLargeProcess(process) {
			const largeProcess = this.large_processes.find((p) => p.id == process.id)
			const index = this.large_processes.indexOf(largeProcess)
			this.large_processes.splice(index, 1)
			this.large_processes.push({
				...process,
				name: process.large_process_type.name,
				category_id: process.order_individual_info_id,
			})
		},
		changeDatetime(large_process) {
			const headers = authenticate.setHeader()
			axios
				.put(`/erp/v1/large_processes/${large_process.id}`, { large_process }, { headers })
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "日程を変更しました。",
					})
					this.updateLargeProcess(res.data)
				})
				.catch((err) => {
					const error = errorHandling.errorResponse(err)
					if (Array.isArray(error)) {
						this.errors = error
					}
				})
		},
		openShowDialog(id) {
			this.$refs.show.openDialog(id)
		},
		openAddTaskDialog(id) {
			this.addCalendarDialog = true
			this.order_individual_info_id = id
		},
	},
	computed: {
		processPresent() {
			return (orderIndividualInfo) => {
				return (
					this.large_processes.find((p) => p.order_individual_info_id == orderIndividualInfo.id) !=
					null
				)
			}
		},
	},
}
</script>
